import { useRef, useState, useEffect } from "react";
import { useLocation } from "react-router";
import { IconButton, Box, Button, Popover, useTheme } from "@mui/material";
import { selectCart } from "@/redux-store/cart";

import { ROUTES } from "@/utils/navigation";
import { selectCartPopUpState } from "@/redux-store/cartPopUp";
import { togglePopUp } from "@/redux-store/cartPopUp/cartPopUpSlice";
import useResponsive from "@/hooks/useResponsive";
import { useAppDispatch, useAppSelector } from "@/redux-store/hooks";

import CartIcon from "@/assets/icons/cart.svg?react";
import CartPopUp from "@/components/Cart/CartPopUp";
import {
  circleStyles,
  getButtonStyles,
  getIconButtonStyles,
  getLabelStyles,
  popUpStyles,
} from "./styles";

const Cart = () => {
  const location = useLocation();
  const cartIsOpen = useAppSelector(selectCartPopUpState);
  const dispatch = useAppDispatch();
  const cartData = useAppSelector(selectCart);
  const theme = useTheme();
  const isTablet = useResponsive("down", "lg");
  const anchorElCart = useRef<HTMLButtonElement>(null);
  const [_anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  useEffect(() => {
    setAnchorEl(anchorElCart?.current);
  }, [anchorElCart.current]);

  const toggleCartPopUp = () => {
    dispatch(togglePopUp());
  };

  if (!cartData || cartData.length === 0) {
    return null;
  }

  return (
    <Box display="flex">
      {isTablet ? (
        <IconButton
          ref={anchorElCart}
          size="large"
          aria-label="cart"
          aria-controls="cart-pop-up"
          aria-haspopup="true"
          onClick={toggleCartPopUp}
          sx={getIconButtonStyles(theme, location.pathname === ROUTES.cart)}
          color="inherit"
        >
          <Box sx={getLabelStyles(true, isTablet)}>
            <Box sx={circleStyles} />
          </Box>
          <CartIcon />
        </IconButton>
      ) : (
        <Button
          ref={anchorElCart}
          variant="outlined"
          color="secondary"
          size="large"
          disableElevation
          onClick={toggleCartPopUp}
          sx={getButtonStyles(theme, location.pathname === ROUTES.cart)}
          startIcon={<CartIcon />}
        >
          <Box sx={getLabelStyles(false, isTablet)}>
            <Box sx={circleStyles} />
          </Box>
          Cart
        </Button>
      )}
      {cartIsOpen && (
        <Popover
          id="cart-pop-up"
          anchorEl={anchorElCart.current}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={cartIsOpen}
          onClose={toggleCartPopUp}
          PaperProps={{ sx: popUpStyles }}
          sx={{ display: anchorElCart.current ? "block" : "none" }}
        >
          <CartPopUp closePopUp={toggleCartPopUp} />
        </Popover>
      )}
    </Box>
  );
};

export default Cart;
